// Export interfaces/types
export {
    default as SearchTableQuery,
    SearchTableScenarioType,
} from './store/schema/SearchTableQuery';

// Export utils
export { default as createMailSearchTableQuery } from './utils/createMailSearchTableQuery';
export { default as getSearchScenarioType } from './utils/getSearchScenarioType';
export { default as isDumpsterSearchTable } from './utils/isDumpsterSearchTable';
